"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const client_1 = require("react-dom/client");
const Alert_1 = __importDefault(require("../../components/Alert"));
const ArrowButton_1 = __importDefault(require("../../components/ArrowButton"));
const Button_1 = __importDefault(require("../../components/Button"));
const IconType_1 = __importDefault(require("../../components/enums/IconType"));
const IdHeader_1 = __importDefault(require("../../components/IdHeader"));
const LegalCheckBox_1 = __importDefault(require("../../components/LegalCheckBox"));
const TextInput_1 = __importDefault(require("../../components/TextInput"));
const IllustrationNoDrawing_1 = __importDefault(require("../../components/illustrations/IllustrationNoDrawing"));
const Register = () => {
    //Screen State Variables
    const [isRegisterError, setIsRegisterError] = (0, react_1.useState)(false);
    const [isRegisterSuccess, setIsRegisterSuccess] = (0, react_1.useState)(false);
    const [isFormFilled, setIsFormFilled] = (0, react_1.useState)(false);
    const [isRegisterLoading, setIsRegisterLoading] = (0, react_1.useState)(false);
    //Error Messages
    var serverErrorMessage = "Acceptance of the Privacy policy is required!";
    //Register Form Variables
    const [email, setEmail] = (0, react_1.useState)("");
    const [password, setPassword] = (0, react_1.useState)("");
    const [firstName, setFirstName] = (0, react_1.useState)("");
    const [lastName, setLastName] = (0, react_1.useState)("");
    const [phone, setPhone] = (0, react_1.useState)("");
    const [isPrivacyAccepted, setIsPrivacyAccepted] = (0, react_1.useState)(false);
    const [isTermsAccepted, setIsTermsAccepted] = (0, react_1.useState)(false);
    //Error states
    const [emailErrorState, setEmailErrorState] = (0, react_1.useState)("");
    const [passwordErrorState, setPassawordErrorState] = (0, react_1.useState)("");
    const [lastNameErrorState, setLastNameErrorState] = (0, react_1.useState)("");
    const [firstNameErrorState, setFirstNameErrorState] = (0, react_1.useState)("");
    const [phoneErrorState, setPhoneErrorState] = (0, react_1.useState)("");
    react_1.default.useEffect(() => {
        if (document.getElementById("react-data")) {
            try {
                let data = document
                    .getElementById("react-data")
                    .getAttribute("encoded");
                let parsed_data = JSON.parse(data);
                if (parsed_data.email) {
                    setEmail(parsed_data.email);
                }
            }
            catch (error) { }
        }
    });
    const resetErrors = () => {
        setIsRegisterSuccess(false);
        setEmailErrorState("");
        setPassawordErrorState("");
        setLastNameErrorState("");
        setFirstNameErrorState("");
        setPhoneErrorState("");
        setIsRegisterError(false);
    };
    const checkInvalidFields = (response) => {
        if (response.message != "invalid_fields") {
            return false;
        }
        if (response.data) {
            for (let i = 0; i < response.data.length; i++) {
                let d = response.data[i];
                if (d == "email") {
                    setEmailErrorState("The entered email is incorrect!");
                }
                if (d == "password") {
                    setPassawordErrorState("The entered password is incorrect!");
                }
                if (d == "phone") {
                    setPassawordErrorState("The entered phone number is incorrect!");
                }
                if (d == "first_name") {
                    setPassawordErrorState("The given first name is not correct!");
                }
                if (d == "family_name") {
                    setPassawordErrorState("The given last name is incorrect!");
                }
            }
        }
    };
    const handleRegisterEvent = (e) => {
        e.preventDefault();
        resetErrors();
        setIsRegisterLoading(true);
        fetch("/register", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                email: email,
                password: password,
                first_name: firstName,
                family_name: lastName,
                phone: phone,
                privacy: isPrivacyAccepted ? "accepted" : "",
                terms: isTermsAccepted ? "accepted" : "",
            }),
        })
            .then((response) => {
            response
                .json()
                .then((content) => {
                if (!content.success) {
                    checkInvalidFields(content.response);
                    if (content.response.message == "documents") {
                        setIsRegisterError(true);
                        return false;
                    }
                    if (content.response.message == "email-taken") {
                        setEmailErrorState("The given email address is already in use!");
                        return false;
                    }
                    return false;
                }
                setIsRegisterSuccess(true);
                if (content.response.action) {
                    window.location.href = content.response.action;
                }
            })
                .catch(() => { });
        })
            .catch(() => { })
            .finally(() => {
            setIsRegisterLoading(false);
        });
    };
    (0, react_1.useEffect)(() => {
        if (email.length !== 0 &&
            password.length !== 0 &&
            firstName.length !== 0 &&
            lastName.length !== 0 &&
            phone.length !== 0 &&
            isPrivacyAccepted &&
            isTermsAccepted) {
            setIsFormFilled(true);
        }
        else {
            setIsFormFilled(false);
        }
    }, [
        email,
        password,
        firstName,
        lastName,
        phone,
        isPrivacyAccepted,
        isTermsAccepted,
    ]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(IdHeader_1.default, { hideBackButton: true, handlerFunction: function () {
                throw new Error("Function not implemented.");
            } }),
        react_1.default.createElement("main", { className: "register" },
            react_1.default.createElement("form", { className: "register__content", onSubmit: handleRegisterEvent, method: "post" },
                react_1.default.createElement("div", { className: "register__form-container" },
                    react_1.default.createElement("h1", { className: "register__title" }, "Registration"),
                    react_1.default.createElement("article", { className: "register__form" },
                        react_1.default.createElement("div", { className: "register__inputs" },
                            react_1.default.createElement(TextInput_1.default, { label: "Email", name: "email", value: email, onChangeHandler: setEmail, placeholder: "example@mail.com", isRequired: true, type: "email", state: emailErrorState != ""
                                    ? "error"
                                    : "normal", errorText: emailErrorState, unit: "" }),
                            react_1.default.createElement(TextInput_1.default, { label: "Password", name: "password", value: password, onChangeHandler: setPassword, placeholder: "Enter your password", isRequired: true, type: "password", state: passwordErrorState != ""
                                    ? "error"
                                    : "normal", errorText: passwordErrorState, unit: "" }),
                            react_1.default.createElement(TextInput_1.default, { label: "First name", name: "firstname", value: firstName, onChangeHandler: setFirstName, placeholder: "Enter your first name", isRequired: true, type: "text", state: firstNameErrorState != ""
                                    ? "error"
                                    : "normal", errorText: firstNameErrorState, unit: "" }),
                            react_1.default.createElement(TextInput_1.default, { label: "Last name", name: "familyname", value: lastName, onChangeHandler: setLastName, placeholder: "Enter your last name", isRequired: true, type: "text", state: lastNameErrorState != ""
                                    ? "error"
                                    : "normal", errorText: lastNameErrorState, unit: "" }),
                            react_1.default.createElement(TextInput_1.default, { label: "Phone number", name: "phone", value: phone, onChangeHandler: setPhone, placeholder: "+77 80 9945675", isRequired: true, type: "tel", state: phoneErrorState != ""
                                    ? "error"
                                    : "normal", errorText: phoneErrorState, unit: "" })),
                        react_1.default.createElement(LegalCheckBox_1.default, { name: "terms", type: "terms", hyperlink: "https://routic.io/terms", value: isTermsAccepted, onChangeHandler: setIsTermsAccepted }),
                        react_1.default.createElement(LegalCheckBox_1.default, { name: "privacy", type: "privacy", hyperlink: "https://routic.io/privacy", value: isPrivacyAccepted, onChangeHandler: setIsPrivacyAccepted }),
                        react_1.default.createElement(Button_1.default, { state: isFormFilled && !isRegisterLoading
                                ? "enabled"
                                : "disabled", label: "Registration", type: "primary", icon: IconType_1.default.None, handlerFunction: () => { }, action: "submit" })),
                    react_1.default.createElement("div", { className: "register__login-button" },
                        react_1.default.createElement(ArrowButton_1.default, { direction: "left", label: "LogIn", handlerFunction: function () {
                                window.location.href = "/login";
                            } })))),
            react_1.default.createElement("div", { className: "register__illustration" },
                react_1.default.createElement("h1", { className: "register__title-mobile" }, "Register"),
                react_1.default.createElement(IllustrationNoDrawing_1.default, null,
                    react_1.default.createElement("div", { style: {
                            display: "flex",
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: "100%"
                        } },
                        react_1.default.createElement("span", { style: {
                                fontSize: "3.2rem",
                                fontFamily: "Fira Sans",
                                color: "rgb(0, 78, 80)",
                                fontWeight: "800",
                                letterSpacing: "0.2rem"
                            } }, "\u201CA journey of a thousand miles begins with a single step\u201D \uD83E\uDD7E"))))),
        react_1.default.createElement(react_1.default.Fragment, null,
            isRegisterError === true ? (react_1.default.createElement(Alert_1.default, { type: "error", label: serverErrorMessage, closeFunction: () => setIsRegisterError(false) })) : (react_1.default.createElement(react_1.default.Fragment, null)),
            isRegisterSuccess === true ? (react_1.default.createElement(Alert_1.default, { type: "success", label: "Successful registration!", closeFunction: () => setIsRegisterSuccess(false) })) : (react_1.default.createElement(react_1.default.Fragment, null)))));
};
exports.default = Register;
if (document.getElementById("guest-register")) {
    (0, client_1.createRoot)(document.getElementById("guest-register")).render(react_1.default.createElement(Register, null));
}
